module.exports = __webpack_public_path__ + "img/img05.f0aec759.png";